// src/utils/parseAnexos.js
//
// Normaliza o campo `anexo_url` que pode chegar em 3 formatos diferentes:
//   1. null / '' / undefined          → []
//   2. ID/URL único (string)          → [valor]      (gasto criado pelo web)
//   3. JSON array de IDs ["a","b"]    → ["a","b"]    (prestação via App mobile)
//
// O App serializa múltiplos anexos como JSON.stringify(ids) em anexo_url
// (ver serializeAnexos no backend). O web sempre gravou um único ID.
// Centralizar isso aqui evita passar um array cru para o AnexoViewerModal
// (que espera um único id/url) — bug que quebrava a visualização de recibos
// enviados pelo App com mais de uma foto.

export function parseAnexos(raw) {
  if (!raw) return [];
  if (Array.isArray(raw)) return raw.filter(Boolean).map(String);

  const s = String(raw).trim();
  if (!s) return [];

  // JSON array vindo do App (ex.: ["1AbC...","1XyZ..."])
  if (s.startsWith('[')) {
    try {
      const arr = JSON.parse(s);
      if (Array.isArray(arr)) return arr.filter(Boolean).map(String);
    } catch {
      /* não era JSON válido — cai para o tratamento de string única abaixo */
    }
  }

  // ID ou URL único
  return [s];
}

export default parseAnexos;